module.exports = __webpack_public_path__ + "static/img/zj_calendar_widget_3.01f0050.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/zj_calendar_widget_3.png
// module id = vb6c
// module chunks = 11